import React, { Component } from 'react';

import appSettings from '../../config/settings';

import { LoadableComponentErrorBoundaryPage } from './LoadableComponentErrorBoundaryPage';

// Use ErrorBoyndary to catch ChunkLoadError
// https://reactjs.org/docs/error-boundaries.html
// Nextmine: hvor længe reload-værnet husker sidste auto-reload. Inden for dette
// vindue viser vi fejlsiden i stedet for at genindlæse igen (undgår reload-loop
// hvis fejlen ikke skyldes et deploy).
const CHUNK_RELOAD_GUARD_MS = 60000;
const CHUNK_RELOAD_KEY = 'nextmineChunkReloadedAt';

const reloadOnceForNewAppVersion = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  try {
    const last = Number(window.sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
    if (Date.now() - last < CHUNK_RELOAD_GUARD_MS) {
      return false;
    }
    window.sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
  } catch (e) {
    // sessionStorage can be unavailable (private mode etc.) - reload anyway;
    // worst case the user sees the fallback page after a second failure.
  }
  window.location.reload();
  return true;
};

class LoadableComponentErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, reloading: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { error };
  }

  componentDidCatch(error) {
    // Nextmine: ChunkLoadError betyder næsten altid at et deploy har udskiftet
    // app'ens filer under brugerens session. En enkelt automatisk genindlæsning
    // henter den nye version og fortsætter på samme URL - ingen død fejlside.
    if (error && error.name === 'ChunkLoadError') {
      const reloading = reloadOnceForNewAppVersion();
      if (reloading) {
        this.setState({ reloading: true });
      }
    }
  }

  render() {
    if (this.state.error && this.state.error.name === 'ChunkLoadError') {
      // Mens den automatiske genindlæsning er i gang: vis ingenting i stedet
      // for at blinke fejlsiden op.
      return this.state.reloading ? null : <LoadableComponentErrorBoundaryPage />;
    }

    return this.props.children;
  }
}

// LoadableComponentErrorBoundary helps in situations
// where production build changes in the server and
// long-living client app tries to fetch code chunks that don't exist anymore.
// Note: in development mode with Hot Module Reloading (HMR) in use, this causes error loops.
const UseLoadableErrorBoundaryOnlyInProdutionMode = props => {
  const { children } = props;
  return appSettings.dev ? (
    children
  ) : (
    <LoadableComponentErrorBoundary>{children}</LoadableComponentErrorBoundary>
  );
};
export default UseLoadableErrorBoundaryOnlyInProdutionMode;
